import { defaultParamList } from '@helpers/constant';
import { RangePickerValue } from 'antd/lib/date-picker/interface';
import React, { Fragment, useEffect, useState } from 'react';
import useAction from '../hooks/useAction';
import useActionTopic from '../../topics/hooks/useAction';
import Filter from './filter';
import Table from './table';

export default function (props: any) {
  const {
    data,
    getData,
    metaData,
    isLoaderData,
    sources,
    getSources,
    isLoaderNewsMedia,
    manualFetch,
    setSelectedRow,
    selectedRow,
    updateNewsCrawlerValues,
    setUpdateNewsCrawlerValues,
    updateData,
    getDetail,
    detail,
  } = useAction();
  const actionTopic = useActionTopic()

  const [params, setParams] = useState({ ...defaultParamList, orderBy: 'postedDate' });

  useEffect(() => {
    fetchData();
  }, [params]);

  useEffect(() => {
    fetchSources();
    fetchTopic()
  }, []);

  const fetchData = (newParams?: any) => {
    const param = {
      ...params,
      ...newParams
    };

    getData(param);
  };

  const fetchSources = () => {
    getSources()
  }

  const fetchTopic = (search?: string) => {
    actionTopic.getData({ page: 1, limit: 20, status: "active", search })
  }

  const onSearch = (search: string) => {
    const param = {
      ...params,
      page: 1,
      search
    }
    setParams(param)
  }

  const onChangeSource = (
    newsMedia: string
  ) => {
    let param = {
      ...params,
      page: 1,
      newsMedia
    }

    if (newsMedia === 'all') {
      delete param.newsMedia
    }

    setParams(param)
  }

  const onChangeStatus = async (
    status: 'draft' | 'all' | 'published' | 'unpublished'
  ) => {
    const param = {
      ...params,
      page: 1,
      status
    }

    setParams(param)
  }

  const onChangeDate = (
    _: RangePickerValue,
    dateStrings: [string, string]
  ) => {
    const param = {
      ...params,
      page: 1,
      startDate: new Date(dateStrings[0]).toISOString(),
      endDate: new Date(dateStrings[1]).toISOString()
    }
    setParams(param)
  }

  const onManualFetch = () => {
    manualFetch(params)
  }

  const onChangeTable = (pagination: any, _: any, sorter: any) => {
    const { current, pageSize } = pagination;
    const sort = sorter.columnKey ? sorter.order : 'desc';
    const orderBy = sorter.columnKey ? sorter.columnKey : 'postedDate';
    const param = {
      ...params,
      limit: pageSize,
      orderBy: orderBy,
      page: pageSize == params.limit ? current : 1,
      sort: sort,
    };
    setParams(param);
  }

  const onPublish = () => {
    const topics = []
    if (updateNewsCrawlerValues.topicId) {
      topics.push(updateNewsCrawlerValues.topicId!)
    } else {
      topics.push(updateNewsCrawlerValues.topicIdDetail!)
    }

    const id = data
      .filter(val => updateNewsCrawlerValues.id?.indexOf(val.id)! > -1)
      .filter(val => val.status !== 'published')
      .map(val => val.id)

    updateData({ ...updateNewsCrawlerValues, status: 'published', topics, id })
    setSelectedRow([])
  }

  const onUnpublish = () => {
    const id = data
      .filter(val => updateNewsCrawlerValues.id?.indexOf(val.id)! > -1)
      .filter(val => val.status === 'published')
      .map(val => val.id)

    updateData({ ...updateNewsCrawlerValues, status: 'unpublished', id })
    setSelectedRow([])
    setUpdateNewsCrawlerValues({ ...updateNewsCrawlerValues, reason: '' })
  }

  const onChangeReason = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setUpdateNewsCrawlerValues({ ...updateNewsCrawlerValues, reason: e.target.value })
  }

  const onChangeId = (id: string[]) => {
    setUpdateNewsCrawlerValues({ ...updateNewsCrawlerValues, id })
  }

  const onCancelUpdate = () => {
    setUpdateNewsCrawlerValues({ ...updateNewsCrawlerValues, topics: [] })
    onCancelToggle()
  }
  const onCancelToggle = () => {
    fetchData();
  }

  const onRefresh = () => {
    const param = {
      ...params,
      limit: 10,
      orderBy: 'postedDate',
      page: 1,
      sort: 'desc',
    };
    fetchData(param);
  }

  return (
    <Fragment>
      <Filter
        {...props}
        dataSource={data}
        onSearch={onSearch}
        onChangeSource={onChangeSource}
        onChangeStatus={onChangeStatus}
        dataListMedia={sources}
        isLoaderListMedia={isLoaderNewsMedia}
        onChangeDate={onChangeDate}
        onManualFetch={onManualFetch}
        onRefresh={onRefresh}
      />
      <Table
        {...props}
        fetchDataList={fetchData}
        loading={isLoaderData}
        dataSource={data}
        metaData={metaData}
        onChangeTable={onChangeTable}
        onPublish={onPublish}
        onUnpublish={onUnpublish}
        onChangeReason={onChangeReason}
        setSelectedRow={setSelectedRow}
        selectedRow={selectedRow}
        updateNewsCrawlerValues={updateNewsCrawlerValues}
        setUpdateNewsCrawlerValues={setUpdateNewsCrawlerValues}
        onChangeId={onChangeId}
        getDetail={getDetail}
        detail={detail}
        onCancelUpdate={onCancelUpdate}
        fetchTopicList={fetchTopic}
        topics={actionTopic.data}
        onCancelToggle={onCancelToggle}
      />
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/pages/news-crawler/libraries/index.tsx